import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./styles";

export const Select = ({
  items,
  onItemClick,
  initialValue,
  classname,
  ariaLabel,
  disabled,
}) => {
  const optionOnClickHandler = (event) => {
    if (onItemClick) {
      onItemClick(event);
    }
  };

  return (
    <select
      className={classnames(styles.select, classname)}
      onChange={optionOnClickHandler}
      aria-label={ariaLabel}
      disabled={disabled}
      value={initialValue}
      autoComplete="off"
    >
      {items &&
        items.map((item) => (
          <option key={item.value || item.description} value={item.value}>
            {item.description}
          </option>
        ))}
    </select>
  );
};

Select.displayName = "Select";

Select.propTypes = {
  /**
   Array of items used to populate the Select element
  */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      description: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  /**
   Callback that returns event.target, itemClicked and openState
  */
  onItemClick: PropTypes.func,
  /**
   The initial item to set the Select with
  */
  initialValue: PropTypes.string,
  /**
   Allows you to add additional classes to the accordion
  */
  classname: PropTypes.string,
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
};

Select.defaultProps = {
  selectIndexOnMount: 0,
  className: "",
  initialValue: "",
};
